<template>
  <modal v-model="model" max-width="600">
    <template #title>Bulk Upload Full Text PDF</template>
    <template #content>
      <p>
        To speed up the process of finding &amp; uploading the full
        text PDFs, we recommend you do the following:
      </p>
      <ol>
        <li>
          Export the references missing their Full Text PDFs and
          import into a new EndNote library - take note of where you
          create this new library.
        </li>
        <li>
          Use EndNote's "Find Full Text PDFs" feature to find and
          download all the required PDFs.
        </li>
        <li>Export the EndNote library to an XML file.</li>
        <li>
          Package the EndNote library data directory into a ZIP file,
          or use EndNote's "Compress Library" feature to create a
          Compressed Library (.enlx) file.
        </li>
        <li>Upload both the XML and ZIP (or .enlx) file below.</li>
      </ol>
      <v-divider class="mt-2 mb-4" />
      <action-button
        color="primary"
        @click="$emit('export-references')"
      >
        <template v-if="!exporting">
          <v-icon left class="material-icons-outlined">
            cloud_download
          </v-icon>
          Export references missing Full Text PDFs
        </template>
        <template v-else>
          <v-progress-circular
            class="mr-2"
            width="2"
            size="20"
            indeterminate
          />
          Exporting...
        </template>
      </action-button>
      <file-selector
        v-model="xmlFile"
        class="mt-4"
        :accept="['.xml']"
      >
        <template #label>
          <div
            class="pa-2 d-flex align-center grey--text text--lighten-1"
          >
            <v-icon class="mr-1">description</v-icon>
            <div class="mr-1">Drop EndNote XML file here or</div>
            <a>browse files</a>
          </div>
        </template>
        <template v-if="xmlFile">
          <div class="d-flex justify-space-between align-center">
            <div>
              <v-icon>description</v-icon>
              {{ xmlFile.name }}
            </div>
            <v-btn icon color="error" @click="xmlFile = null">
              <v-icon>remove_circle</v-icon>
            </v-btn>
          </div>
        </template>
      </file-selector>
      <file-selector
        v-model="zipFile"
        class="mt-4"
        :accept="['.zip', '.enlx']"
      >
        <template #label>
          <div
            class="pa-2 d-flex align-center grey--text text--lighten-1"
          >
            <v-icon class="mr-1">picture_as_pdf</v-icon>
            <div class="mr-1">
              Drop EndNote Directory ZIP or .enlx file here or
            </div>
            <a>browse files</a>
          </div>
        </template>
        <template v-if="zipFile">
          <div class="d-flex justify-space-between align-center">
            <div>
              <v-icon>picture_as_pdf</v-icon>
              {{ zipFile.name }}
            </div>
            <v-btn icon color="error" @click="zipFile = null">
              <v-icon>remove_circle</v-icon>
            </v-btn>
          </div>
        </template>
      </file-selector>
    </template>
    <template #actions>
      <action-button class="mr-2" @click="onCancel">
        Cancel
      </action-button>
      <action-button
        color="primary"
        :disabled="disableUpload"
        @click="onUpload"
      >
        <v-icon left class="material-icons-outlined">
          cloud_upload
        </v-icon>
        Upload
      </action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';
import FileSelector from '@/components/Common/FileSelector';

export default {
  name: 'BulkUploadFullTextPdfDialog',
  components: { ActionButton, Modal, FileSelector },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    exporting: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    xmlFile: null,
    zipFile: null,
  }),
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    disableUpload() {
      return !this.xmlFile || !this.zipFile;
    },
  },
  methods: {
    onCancel() {
      this.xmlFile = null;
      this.zipFile = null;
      this.model = false;
    },
    onUpload() {
      this.$emit('upload', {
        xmlFile: this.xmlFile,
        zipFile: this.zipFile,
      });
      this.xmlFile = null;
      this.zipFile = null;
    },
  },
};
</script>
